// Depends
import { subGroup, route, professionalMeta } from '@/helpers/routes'
import Index from './index/index'
import Form from './form/form'

const routes = [
  route('index', '/index', Index, professionalMeta('Lista de Bloqueios')),
  route('create', '/create', Form, professionalMeta('Adicionar Bloqueio')),
  route('edit', '/:id/edit', Form, professionalMeta('Editar Bloqueio'))
]

export default subGroup('/locks', routes)



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/routes.js